import React, { useContext, useState } from "react";
import {
  Grid2,
  Menu,
  Checkbox,
  MenuItem,
  IconButton,
  useTheme,
} from "@mui/material";
import { Add, ArrowDropDown, ArrowDropUp, X } from "@mui/icons-material";
import LanguageContext from "../Layout/Contexts/LanguageTextContext";
import Text, { translate } from "../genericComponents/Text";

const GridHeader = ({
  typeName,
  activeColumns,
  setActiveColumns,
  allColumns,
  activeSort,
  sortInverted,
  setSortInverted,
  setActiveSort
}) => {

  const checkableColumns = allColumns.filter(x => x.dataType !== "ID" && x.dataType !== "ID[]");
  const [anchorEl, setAnchorEl] = useState();
  const theme = useTheme();
  const handleClick = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const handleNewSorting = propertyName => {
    if (propertyName === activeSort) {
      setSortInverted(!sortInverted);
    } else {
      setSortInverted(false);
      setActiveSort(propertyName);
    }
  };

  const handleActiveColumns = tab => {
    const newActiveColumns = [...activeColumns];
    const tabIndex = newActiveColumns.findIndex((x) => x === tab);
    if (tabIndex >= 0) {
      if (newActiveColumns.length !== 1) {
        newActiveColumns.splice(tabIndex, 1);
      }
    } else {
      newActiveColumns.push(tab);
    }
    setActiveColumns(newActiveColumns);
  };
  const translations = useContext(LanguageContext);
  const translatedCheckableColumns=[];
  for(let i=0;i<checkableColumns.length;i++){
    translatedCheckableColumns.push(
      {text: translate(translations, `i18n_${typeName}_${checkableColumns[i].propertyName.toLowerCase()}`),
      propertyName:checkableColumns[i].propertyName,})
  }  
  return (
    <Grid2
      container
      style={{
        border: `2px solid ${theme.palette.primary.main}`,
      }}
    >
      <Grid2 style={{ width: 48 }}>
        <IconButton
          onClick={handleClick}
          style={{
            color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
          }}>
          <Add />
        </IconButton>
      </Grid2>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={handleClose}
      >
        {translatedCheckableColumns.sort((a, b) => {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        }).map((checkableColumn, i) => (
          <MenuItem onClick={() => handleActiveColumns(checkableColumn.propertyName)} key={i}>
            <Checkbox disableRipple
              disabled
              checked={!!activeColumns.find(y => y === checkableColumn.propertyName)}
              style={{ color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main, padding: theme.spacing(1) }}
            />
            <Text isPreTranslated={true} text={checkableColumn.text} />
          </MenuItem>
        ))}
      </Menu>
      {activeColumns.map((activeColumnName, i) => (
        <div
          style={{
            flex: 1,
            cursor: "pointer",
            userSelect: "none",
            display: "flex",
            alignItems: "center",
          }}
          key={i}
          onClick={() => handleNewSorting(activeColumnName)}
        >
          <Text text={`i18n_${typeName}_${activeColumnName.toLowerCase()}`} variant="subtitle2" />
          {activeSort === activeColumnName && !sortInverted ? (
            <ArrowDropUp />
          ) : (
            activeSort === activeColumnName && <ArrowDropDown />
          )}
        </div>
      ))}
    </Grid2>
  );
};

export default GridHeader;
